// Misc. Utility Functions

export function isSafari(): boolean {
	if (typeof navigator === "undefined") {
		return false;
	}
	const ua = navigator.userAgent;
	return (
		ua.includes("Safari") &&
		!ua.includes("Chrome") &&
		!ua.includes("CriOS") &&
		!ua.includes("Chromium") &&
		!ua.includes("FxiOS") &&
		!ua.includes("Edg")
	);
}
